<template>
  <div>
    <v-form ref="chargeCreditForm" v-model="chargeCreditValid">
      <v-row class="pa-5">
        <v-col cols="12" sm="6">
          <v-select
            label="روش پرداخت"
            v-model="paymentType"
            dense
            :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
            required
            item-text="displayName"
            item-value="title"
            :items="paymentTypes"
            outlined
            
          >
          </v-select>
          <v-sheet outlined class="p-5" rounded v-if="paymentType">
            <div v-if="paymentType == 'Wallet'">
              <div>
                <span
                  >موجودی کیف پول شما
                  <strong
                    >{{ credit.totalCredit.amount | priceSplitter }}
                  </strong>
                  ریال است .</span
                >
              </div>
              <div v-if="needPrice > 0">
                کسری وجه کیف پول :
                <span class="text-site-color">
                  {{ needPrice | priceSplitter }} ریال</span
                >
                <v-btn
                  class="mt-3"
                  small
                  color="primary"
                  @click="openChargeCreditForm()"
                  v-if="!showChargeCreditForm && !paymentForRetrayPayHasData"
                >
                  شارژ کیف پول
                </v-btn>
                <div
                  v-if="paymentForRetrayPayHasData && !showChargeCreditForm"
                  class="mt-3"
                >
                  <v-icon color="warning">mdi mdi-alert-outline </v-icon>
                  <b>
                    شما یک یا چند پرداخت ناموفق دارید لطفا ابتدا پرداخت های
                    ناموفق خود را تعیین تکلیف کنید.</b
                  >
                  <div>
                    <v-btn
                      class="mt-3"
                      small
                      color="primary"
                      @click="goToWalletPage()"
                    >
                      نمایش لیست پرداخت ها
                    </v-btn>
                  </div>
                </div>
                <div
                  v-else-if="
                    !paymentForRetrayPayHasData && showChargeCreditForm
                  "
                >
                  <wallet-form
                    @closeCreditForm="closeCreditForm"
                    :needPrice="needPrice"
                    sourceType="WalletCharge"
                  ></wallet-form>
                </div>
              </div>
              <div v-else>
                <v-btn
                  class="mt-3"
                  small
                  color="primary"
                  @click="payByWallet()"
                >
                  استفاده از موجودی کیف پول
                </v-btn>
              </div>
            </div>

            <div v-else-if="paymentType == 'Online'">
              <wallet-form
                v-if="totalPrice"
                @closeCreditForm="closeCreditForm"
                :needPrice="totalPrice.amount"
                :objectId="objectId"
                :sourceType="sourceType"
              ></wallet-form>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
      <v-row v-if="succeed != undefined">
        <v-col cols="12">
          <payment-status
            :succeed="succeed"
            :paymentId="paymentId"
            ref="PaymentStatusRef"
          ></payment-status>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const paymentRepository = () => RepoFactory.get('payment');
const enumRepository = () => RepoFactory.get('enums');
const walletTransactionsRepository = () =>
  RepoFactory.get('walletTransactions');
import WalletForm from '@/modules/FinancialManagement/wallet/components/WalletForm.vue';
import PaymentStatus from '@/modules/FinancialManagement/wallet/components/PaymentStatus.vue';
import Helper from '@/core/helpers';
export default {
  components: {
    WalletForm,
    PaymentStatus,
  },
  props: {
    totalPrice: {
      type: Object,
      default: null,
    },
    objectId: {
      type: String,
      default: null,
    },
    sourceType: {
      type: String,
      default: null,
    },
    sourceTypeForWalletPay: {
      type: String,
      default: null,
    },
    getMembershipAndPrice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chargeCreditValid: true,
      paymentTypes: [],
      paymentType: 'Wallet',
      credit: {totalCredit:{amount:0}},
      showChargeCreditForm: false,
      paymentForRetrayPayHasData: false,
    };
  },
  computed: {
    succeed() {
      return this.$route.query.succeed == 'true'
        ? true
        : this.$route.query.succeed == 'false'
        ? false
        : undefined;
    },
    paymentId() {
      return this.$route.query.paymentId;
    },
    needPrice() {
      let price = 0;
      if (
        this.totalPrice &&
        this.totalPrice.amount &&
        this.credit &&
        this.credit.totalCredit &&
        this.credit.totalCredit.amount >= 0
      ) {
        if (this.totalPrice.amount > this.credit.totalCredit.amount) {
          price = this.totalPrice.amount - this.credit.totalCredit.amount;
        }
      }
      return price;
    },
    paymentBaseUrl() {
      return this.$store.getters.paymentBaseUrl;
    },
    MerchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  created() {
    this.getPaymentTypes();
    this.getWalletTransactionsCredit();
  },
  watch: {
    paymentType(after, before) {
      if (after == 'Wallet') {
        this.openChargeCreditForm();
      }
    },
  },
  methods: {
    getHasPayment() {
      this.$emit('getHasPayment');
    },
    payByWallet() {
      const loader = this.$loading.show();
      let body = {
        sourceType: this.sourceType,
        amount: this.totalPrice,
        receiverMerchantId: null,
        payerMerchantId: this.MerchantId,
        sourceObjectId: this.objectId,
      };
      paymentRepository()
        .payByWallet(body, this.$store.getters['paymentBaseUrl'])
        .then((res) => {
          this.$dialog.message.success(' با موفقیت پرداخت شد. ', {
            position: 'top-left',
          });
          this.getHasPayment();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getWalletTransactionsCredit() {
      const loader = this.$loading.show();
      walletTransactionsRepository()
        .getWalletTransactionsCredit(this.$store.getters.walletBaseUrl)
        .then((res) => {
          this.credit = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          console.log(error);
        })
        .finally(() => {
          loader.hide();
        });
    },
    closeCreditForm() {
      this.showChargeCreditForm = false;
    },
    openChargeCreditForm() {
      const loader = this.$loading.show();
      paymentRepository()
        .getPaymentForRetrayPay(this.$store.getters['paymentBaseUrl'])
        .then((res) => {
          if (res.data.length > 0) {
            this.paymentForRetrayPayHasData = true;
            this.showChargeCreditForm = false;
          } else {
            this.paymentForRetrayPayHasData = false;
            this.showChargeCreditForm = true;
            this.$refs.PaymentStatusRef.alert = false;
          }
        })
        .catch((err) => {
          Helper.redirectPage(err, redirect);
        })
        .finally(() => {
          loader.hide();
        });
    },
    getPaymentTypes() {
      const loader = this.$loading.show();
      enumRepository()
        .getEnum('PaymentType', this.paymentBaseUrl)
        .then((res) => {
          this.paymentTypes = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    goToWalletPage() {
      this.$router.replace({
        path: '/financial-management/wallet',
        query: {
          showWalletForm: false,
          amount: this.needPrice,
        },
      });
    },
  },
};
</script>

<style></style>
